import { createAsyncThunk } from '@reduxjs/toolkit';
import { AxiosResponse } from 'axios';

import {
  adminCreateNewSupplement,
  adminSupplementMarkAsMedication,
  adminSupplementMatchExisting,
  adminSupplementNeedsMoreInfo,
} from '@api/adminSupplements';
import { getSupplementDetails } from '@api/supplements';
import {
  IAdminSupplementCreateNewPayload,
  IAdminSupplementMarkAsMedicationPayload,
  IAdminSupplementMatchExistingPayload,
  IAdminSupplementNeedsMoreInfoPayload,
} from '@interfaces/adminSupplements';
import { IDietarySupplementDetails } from '@interfaces/supplements';

export const handleAdminCreateNewSupplement = createAsyncThunk<
  AxiosResponse<Record<string, unknown>>,
  IAdminSupplementCreateNewPayload
>('adminCreateNewSupplement', adminCreateNewSupplement);

export const handleGetAdminMatchingSupplement = createAsyncThunk<
  AxiosResponse<IDietarySupplementDetails>,
  number
>('getAdminMatchingSupplement', getSupplementDetails);

export const handleAdminSupplementMatchExisting = createAsyncThunk<
  AxiosResponse<Record<string, unknown>>,
  IAdminSupplementMatchExistingPayload
>('adminSupplementMatchExisting', adminSupplementMatchExisting);

export const handleAdminSupplementNeedsMoreInfo = createAsyncThunk<
  AxiosResponse<Record<string, unknown>>,
  IAdminSupplementNeedsMoreInfoPayload
>('adminSupplementNeedsMoreInfo', adminSupplementNeedsMoreInfo);

export const handleAdminSupplementMarkAsMedication = createAsyncThunk<
  AxiosResponse<Record<string, unknown>>,
  IAdminSupplementMarkAsMedicationPayload
>('adminSupplementMarkAsMedication', adminSupplementMarkAsMedication);
